import React from "react";
import { Container, Box, Typography, Button, Paper, Grid } from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material/styles";
 

const theme = createTheme({
  palette: {
    primary: { main: "#7E57C2" }, // Purple color for header
  },
  typography: {
    fontFamily: "Poppins, sans-serif",
  },
});

const CoursesTests = () => {
  return (
    <ThemeProvider theme={theme}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "100vh",
          backgroundImage: `url(image/background.jpg)`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          padding: 2,
        }}
      >
        <Container maxWidth="lg" sx={{ textAlign: "center" }}>
          {/* Logo */}
          <Box sx={{ mb: 3 }}>
            <img src='/image/Actify365.png' alt="Actify365 Logo" width="180" />
          </Box>

          {/* Cards Container */}
          <Grid container spacing={4} justifyContent="center">
            {/* Pre-Assessment Test Card */}
            <Grid item xs={12} sm={6} md={5}>
              <Paper
                elevation={5}
                sx={{
                  borderRadius: 3,
                  overflow: "hidden",
                  textAlign: "center",
                  backgroundColor: "white",
                }}
              >
                <Box
                  sx={{
                    backgroundColor: "primary.main",
                    color: "white",
                    p: 2,
                    display: "flex",
                    alignItems: "center",
                    gap: 2,
                    justifyContent: "left",
                  }}
                >
                  <img src='/image/q.png' alt="Test Icon" width="40" />
                  <Typography variant="h6">PRE-Assessment <b>TEST</b></Typography>
                </Box>

                <Box sx={{ p: 3 }}>
                  <img src='image/assessment-icon.png' alt="Test Illustration" width="100%" style={{ maxHeight: "200px" }} />
                </Box>

                <Box sx={{ p: 2 }}>
                  <Button
                    variant="contained"
                    sx={{
                      backgroundImage: "url(/assets/login-button.png)", // Ensure image is available
                      backgroundSize: "cover",
                      color: "white",
                      fontWeight: "bold",
                      width: "80%",
                      py: 1.5,
                    }}
                  >
                    LET'S GO
                  </Button>
                </Box>
              </Paper>
            </Grid>

            {/* Actify365 Course Card */}
            <Grid item xs={12} sm={6} md={5}>
              <Paper
                elevation={5}
                sx={{
                  borderRadius: 3,
                  overflow: "hidden",
                  textAlign: "center",
                  backgroundColor: "white",
                }}
              >
                <Box
                  sx={{
                    backgroundColor: "primary.main",
                    color: "white",
                    p: 2,
                    display: "flex",
                    alignItems: "center",
                    gap: 2,
                    justifyContent: "left",
                  }}
                >
                  <img src='/image/course-icon2.png' alt="Course Icon" width="40" />
                  <Typography variant="h6">ACTIFY365 <b>COURSE</b></Typography>
                </Box>

                <Box sx={{ p: 3 }}>
                  <img src='/image/course-icon.png' alt="Course Illustration" width="100%" style={{ maxHeight: "200px" }} />
                </Box>

                <Box sx={{ p: 2 }}>
                  <Button
                    variant="contained"
                    href="step2.php"
                    sx={{
                      backgroundImage: "url(/assets/login-button.png)",
                      backgroundSize: "cover",
                      color: "white",
                      fontWeight: "bold",
                      width: "80%",
                      py: 1.5,
                    }}
                  >
                    LET'S GO
                  </Button>
                </Box>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </ThemeProvider>
  );
};

export default CoursesTests;
